import moment from 'moment-timezone';

export const KOSOVO_COUNTRY_CODE = 'XK';

const COUNTRY_TIMEZONE_MAP = {
    [KOSOVO_COUNTRY_CODE]: 'Europe/Belgrade',
    LT: 'Europe/Vilnius',
};

export const getTimezoneForCountry = country => COUNTRY_TIMEZONE_MAP[country] || moment.tz.guess();

export const getGmtOffset = (country) => {
    if (country !== KOSOVO_COUNTRY_CODE) {
        return '';
    }

    const timezone = getTimezoneForCountry(country);
    const gmtOffset = moment.tz(timezone).format('Z');

    return ` (GMT${gmtOffset})`;
};

export const createMoment = (timestamp, country) => {
    // For Kosovo, we need to add 1 hour to the timestamp, server returns it in Vilnius timezone
    const adjustedTimestamp = country === KOSOVO_COUNTRY_CODE ? timestamp + 3600 : timestamp;
    return moment(adjustedTimestamp * 1000);
};
